<div class="client_pageBody space_book_page lg:max-w-[500px] space-y-10" *ngIf="object">
  <div class="flex flex-col items-center space-y-4">
    <div>
      <img src="/silone/silone_yo.png" style="height: 120px;" />
    </div>
    <div class="font-bold text-2xl">
      {{object.member?.name}}{{_common.invite_you}}
    </div>
  </div>

  <!-- <div>{{object.id}}</div> -->
  <div class="card">
    <div class="cardBody">
      <div>{{_common.Location}}: {{lang(object.space.location.name,object.space.location.name_lang)}}</div>
      <ng-container *ngIf="object.space.location.googleMapUrl">
        <div>{{_common.google_map}}: {{object.space.location.googleMapUrl}}</div>
      </ng-container>
      <div>{{_common.address}}: {{lang(object.space.location.address,object.space.location.address_lang)}}</div>
      <div>{{_common.Space}}: {{lang(object.space.name,object.space.name_lang)}}</div>
      <div>{{_common.date}}: {{formatLongDate(session.lang, object.startTime)}}</div>
      <div>{{_common.time}}: {{formatDisplayTime(this.session.lang,object.startTime)}}-
        {{formatDisplayTime(this.session.lang,object.endTime)}}
        ({{formatMins(object.durationMins,_common)}})</div>

    </div>

  </div>

  <!-- <ng-container *ngIf="object.space; let o">
    <app-space-card [space]="$any(object.space)" class="space_card_noBorder"></app-space-card>
  </ng-container> -->
  <ng-container
    *ngIf="!isOwner && !object.endTime.isBefore(nowTime) && object.status!=statusList.cancelled && session.user.memberType?.code != 'outsider'">
    <div class="w-full text-center flex flex-col justify-center items-center">
      <div>{{_common.invite_reminder}}</div>
      <div class="client_button mt-4" (click)="accept()">{{_common.invite_accept}}</div>
    </div>
  </ng-container>

  <div class=" mt-4 w-full flex justify-center">

    <!--Error-->
    <div class="text-xl font-bold text-center space-y-2">
      <div *ngIf="isOwner" class="text-red-500">
        {{_common.invite_owner_error}}
      </div>

      <div *ngIf="object.endTime.isBefore(nowTime)" class="text-gray-600">
        {{_common.invite_ended_error}}
      </div>
      <div *ngIf="object.status==statusList.cancelled" class="text-gray-600">
        {{_common.invite_cancelled_error}}
      </div>
      <div *ngIf="session.user && session.user.memberType?.code == 'outsider'" class="text-red-500">
        {{_common.invite_outsider_error}}
      </div>



    </div>
  </div>



</div>